import { PlaceholderSegment } from '@britishcouncil/react-admin';
import { Centered } from 'components';
import { LinkSessionButton } from './LinkSessionButton';

export const NoLinkedSpeakingSessionsPlaceholder = () => {
  return (
    <Centered>
      <PlaceholderSegment
        icon={'calendar alternate'}
        color="grey"
        title={`No linked speaking sessions`}
      >
        <LinkSessionButton />
      </PlaceholderSegment>
    </Centered>
  );
};
